import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=7975339c&"
import script from "./ProjectManage.vue?vue&type=script&lang=js&"
export * from "./ProjectManage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports